var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hello",staticStyle:{"padding":"0 20px"}},[_c('a',{staticStyle:{"display":"inline-flex","float":"left","padding":"11.5px 0px"},attrs:{"href":"https://www.u-media.com.tw"}},[_c('img',{attrs:{"src":require("../assets/logo_new.svg"),"alt":"宇智網通","title":"宇智網通"}})])])
}]

export { render, staticRenderFns }